<span class="order-integration-services">
  @if (!loaded) {
  <app-horus-loader></app-horus-loader>
  } @else if(loaded && serviceInfo) { @if (serviceInfo!.hasAria > 0) {
  <a (click)="redirectSection.emit('REQUEST_TICKETS')">
    <img src="../../../../../assets/icons/icon-aria.svg" alt="" />
  </a>
  } @if (serviceInfo!.hasRex > 0) {
  <a (click)="redirectSection.emit('REQUEST_TICKETS')">
    <img src="../../../../../assets/icons/icon-rex.svg" alt="" />
  </a>
  } @if (serviceInfo!.hasService > 0) {
  <a (click)="redirectSection.emit('SERVICES')">
    <mat-icon fontSet="material-icons-outlined">build</mat-icon>
  </a>

  } }
</span>
